var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('main', {
    class: [{
      loaded: _vm.loaded
    }, '-mt-10 sm-md:mt-0' /*, 'pt-32 sm-md:pt-20'*/]
  }, [_c('loading-overlay', {
    attrs: {
      "wait-for": _vm.processing,
      "tracking": {
        class: 'members-area-card',
        subclass: 'page'
      }
    },
    model: {
      value: _vm.loaded,
      callback: function ($$v) {
        _vm.loaded = $$v;
      },
      expression: "loaded"
    }
  }), _vm._v(" "), !_vm.processing ? _c('transition', {
    attrs: {
      "name": "slide-fade",
      "mode": "out-in"
    }
  }, [_c('Teleport', {
    attrs: {
      "to": "body"
    }
  }, [_c('disclosure-modal', {
    attrs: {
      "view-only": true,
      "show": _vm.showDisclosure,
      "disclosure": _vm.disclosureFile,
      "metadata": _vm.metadataForCurrentPolicy
    }
  })], 1)], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };